module.exports = __webpack_public_path__ + "static/WEDDING E&M-324-1a86fadf8ba736034a716646216142fa.jpg";